export default __webpack_public_path__ + "static/media/hand.a7c18600.png";